module.exports = __webpack_public_path__ + "roboto-v15-latin-regular.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/primeng/resources/themes/omega/fonts/roboto-v15-latin-regular.woff2
// module id = 525
// module chunks = 321 325